import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));
